import {Component, computed, inject, input} from '@angular/core';
import {ProviderTenderRfqControllerService, TenderDetailResponse} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {ProposalParameterPanelsComponent} from '../../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-1-proposal-parameter/components/contract-parameter-panels/proposal-parameter-panels.component';

@Component({
  selector: 'app-tender-project-rfq-proposal-parameters',
  imports: [LoadingComponent, ProposalParameterPanelsComponent],
  templateUrl: './tender-rfq-proposal-parameters.component.html',
})
export class TenderRfqProposalParametersComponent {
  private readonly providerTenderRfqController = inject(ProviderTenderRfqControllerService);

  tenderDetails = input.required<TenderDetailResponse>();

  protected readonly tenderId = computed(() => this.tenderDetails()?.tenderId);

  protected readonly projectId = computed(() => this.tenderDetails().projectId);

  readonly contractParametersResource = rxResource({
    params: () => ({
      tenderId: this.tenderId(),
    }),
    stream: ({params: request}) =>
      this.providerTenderRfqController.getContractParametersContainer1(request),
  });
}
